import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { getGroupId } from 'store/session/selectors';

import {
  fetchManufacturerNotes,
  types,
  updateManufacturerNotes,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_MANUFACTURER_NOTES_REQUEST,
    watchUpdateManufacturersNotes,
  );
}

function* watchFetchManufacturerNotes() {
  try {
    const groupId = yield select(getGroupId);
    const { manufacturerNotes } = yield call(
      API.supplier.getManufacturerNotes,
      groupId,
    );
    yield put(fetchManufacturerNotes.success({ manufacturerNotes }));
  } catch (error) {
    console.error('FAILED TO FETCH MANUFACTURER NOTES', error);
    yield put(fetchManufacturerNotes.error({ error }));
  }
}

function* watchUpdateManufacturersNotes(action) {
  try {
    const groupId = yield select(getGroupId);
    const { newManufacturerNotes } = action.payload;
    const { manufacturerNotes } = yield call(
      API.supplier.updateManufacturerNotes,
      groupId,
      {
        manufacturerNotes: newManufacturerNotes,
      },
    );
    yield put(updateManufacturerNotes.success({ manufacturerNotes }));
  } catch (error) {
    yield put(updateManufacturerNotes.error(error));
  }
}

export function* initSaga() {
  yield all([watchFetchManufacturerNotes()]);
}
